import { useState as u, useEffect as p } from "react";
import { GoogleAnalytics as o } from "../../../../js/analytics/google/index.js";
function y(s, t) {
  const [f, l] = u(!1);
  return p(() => {
    if (!s && !t)
      return;
    const e = [];
    s && e.push(
      o.loadGa(s)
    ), t && e.push(
      o.loadGTM(t)
    ), Promise.all(e).then(() => l(!0));
  }, [s, t]), {
    isReady: f
  };
}
export {
  y as useGoogleAnalytics
};
//# sourceMappingURL=useGoogleAnalytics.js.map
